interface Topic {
  tag: string;
  hot: number;
  trend: 'up' | 'down' | 'new';
}

const topics: Topic[] = [
  { tag: '#某顶流恋情曝光', hot: 982, trend: 'up' },
  { tag: '#综艺翻车名场面', hot: 876, trend: 'up' },
  { tag: '#明星学历造假', hot: 754, trend: 'new' },
  { tag: '#带货主播塌房', hot: 721, trend: 'up' },
  { tag: '#韩娱公司压榨', hot: 689, trend: 'new' },
  { tag: '#片酬内幕曝光', hot: 645, trend: 'up' },
  { tag: '#演唱会取消潮', hot: 598, trend: 'down' },
  { tag: '#网红人设崩塌', hot: 567, trend: 'up' },
  { tag: '#选秀黑幕揭秘', hot: 534, trend: 'down' },
  { tag: '#明星偷税漏税', hot: 498, trend: 'new' },
  { tag: '#剧组内部矛盾', hot: 476, trend: 'up' },
];

const SectionTopics = () => (
  <section id="topics" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
        <p className="mt-2 text-sm text-foreground-500">实时热搜，掌握吃瓜风向标</p>
      </div>
      <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
        {topics.map((topic) => (
          <span
            key={topic.tag}
            className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{topic.tag}</span>
            <span className="flex items-center gap-0.5 text-xs text-foreground-400">
              {topic.trend === 'up' && <i className="ri-arrow-up-line text-primary-500"></i>}
              {topic.trend === 'down' && <i className="ri-arrow-down-line text-secondary-400"></i>}
              {topic.trend === 'new' && <i className="ri-sparkling-line text-accent-500"></i>}
              {topic.hot}万
            </span>
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default SectionTopics;